
export interface ILanguageRequest{
    languageId: number,
    variableId: number,
    variable: string,
    text: string
}
